import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cross from "../../assets/images/icon/cross.svg";
import { faImage, faLock, faUpload } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { at, attempt, isEmpty } from "lodash";
import { uploadUserDocuments } from "helpers/backend_helper";
import { getUserInfo } from "helpers/authHelper";
import { bytesToMB } from "helpers/common";
import { faImages } from "@fortawesome/free-regular-svg-icons";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import edit_icon from "../../assets/images/icon/edit.svg";
import { Button } from "reactstrap";
import { useTranslation } from "react-i18next";
import { checkPermissionStatus, generateMaskedPII } from "helpers/utils";

const VoterDetails = props => {
  const { t } = useTranslation();
  const [attachmentFile, setAttachmentFile] = useState(null);
  const [userDetails, setUserDetails] = useState({
    voterIdNumber: "",
    fullName: "",
    parentName: "",
    gender: "Male",
    dob: "",
    address: "",
    issueDate: "",
  });
  const [viewType, setViewType] = useState("view");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const candidateDetails = props?.data?.fields
    ? JSON.parse(props?.data?.fields)
    : "";

  const validateVoterID = val => {
    let inputvalues = val;
    let regex = new RegExp(/^[A-Z]{3}[0-9]{7}$/);
    return regex.test(inputvalues);
  };

  const imageTypeAllowed = [
    "application/doc",
    "application/docx",
    "image/png",
    "image/jpg",
    "image/jpeg",
    "application/msword",
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];

  const handleFileUpload = async e => {
    setErrors({ ...errors, attachmentFile: "" });
    if (e?.target?.files?.length > 0) {
      let maxSize = 25;
      let isError = false;
      if (e?.target?.files?.length > 1) {
        toast.error(t(`Voter Details.Cannot Select More than one Attachment`));
        return false;
      }
      for (let i = 0; i < e?.target?.files?.length; i++) {
        if (!imageTypeAllowed?.includes(e?.target?.files[i]?.type)) {
          isError = true;
        }
        let megabytes = bytesToMB(e?.target?.files[i].size);
        if (megabytes > maxSize) {
          toast.error(
            t(`Voter Details.Please select attachment of size below 25 MB`)
          );
          return false;
        }
        setAttachmentFile(e?.target?.files[i]);
      }
      if (isError) {
        toast.error(
          t(`Voter Details.Please upload attachment with the following types`)
        );
        return;
      }
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    let error = {};
    let isError = false;
    setLoading(true);
    if (isEmpty(userDetails?.voterIdNumber)) {
      error = {
        ...error,
        voterIdNumber: t(`Voter Details.This Field is Required`),
      };
      isError = true;
    }
    if (!attachmentFile) {
      error = {
        ...error,
        attachmentFile: t(`Voter Details.Attachment is Required`),
      };
      isError = true;
    }
    if (isEmpty(userDetails?.fullName)) {
      error = { ...error, fullName: t(`Voter Details.This Field is Required`) };
      isError = true;
    }
    if (isEmpty(userDetails?.parentName)) {
      error = {
        ...error,
        parentName: t(`Voter Details.This Field is Required`),
      };
      isError = true;
    }
    if (isEmpty(userDetails?.gender)) {
      error = { ...error, gender: t(`Voter Details.This Field is Required`) };
      isError = true;
    }
    if (!userDetails?.dob) {
      error = { ...error, dob: t(`Voter Details.This Field is Required`) };
      isError = true;
    }
    if (isEmpty(userDetails?.address)) {
      error = { ...error, address: t(`Voter Details.This Field is Required`) };
      isError = true;
    }
    if (!userDetails?.issueDate) {
      error = {
        ...error,
        issueDate: t(`Voter Details.This Field is Required`),
      };
      isError = true;
    }

    if (!userDetails?.voterIdNumber?.trim()) {
      error = {
        ...error,
        voterIdNumber: t(`Voter Details.Please Enter Valid Details`),
      };
      isError = true;
    }

    if (isError) {
      toast.error(t(`Voter Details.Please Enter Valid Details`));
      setErrors(error);
      setLoading(false);
      return false;
    }

    let userID = props?.user_id;

    let payload = {
      ...userDetails,
      type: "voterDetails",
      new_status: "Govt. ID Details",
      attachmentFile: attachmentFile,
      appl_id: props?.appl_id,
    };

    await uploadUserDocuments(payload, userID)
      .then(res => {
        toast.success(
          t(`Voter Details.Government ID Details Updated Successfully`)
        );
        props?.onSubmit();
        setLoading(false);
        setViewType("view");
      })
      .then(err => {
        if (err?.response?.message) {
          toast.error(JSON.stringify(err?.response?.message));
        }
        setLoading(false);
      });
  };

  const handleAttachmentOpen = () => {
    if (attachmentFile) {
      if (typeof attachmentFile === "string") {
        window.open(attachmentFile);
      } else {
        window.open(URL.createObjectURL(attachmentFile));
      }
    }
  };

  const handleReset = () => {
    if (props?.data?.fields) {
      let myData = JSON.parse(props?.data?.fields || "{}");
      let attachmentNew = props?.data?.files;
      setUserDetails({
        voterIdNumber: myData?.voterIdNumber,
        fullName: myData?.fullName,
        parentName: myData?.parentName,
        gender: myData?.gender,
        dob: new Date(myData?.dob),
        address: myData?.address,
        issueDate: myData?.issueDate,
      });
      setAttachmentFile(attachmentNew);
    }
  };

  useEffect(() => {
    if (props?.data?.fields) {
      let myData = JSON.parse(props?.data?.fields || "{}");
      let attachmentNew = props?.data?.files;
      setUserDetails({
        voterIdNumber: myData?.voterIdNumber,
        fullName: myData?.fullName,
        parentName: myData?.parentName,
        gender: myData?.gender,
        dob: new Date(myData?.dob),
        address: myData?.address,
        issueDate: myData?.issueDate,
      });
      setAttachmentFile(attachmentNew);
    }
  }, [props?.data]);

  return (
    <>
      {/* <div className="modal-header  d-flex justify-content-between align-items-center">
        <h4 className="m-0">
          {viewType === "edit" ? "Upload" : "View"} Government ID Card Details
        </h4>
      </div> */}
      <div className="d-flex justify-content-between align-items-center modal-subheading mb-2">
        <h4 className="d-flex gap-2 align-items-center mb-1">
          {/* <span></span> */}
          {t(`Voter Details.Government ID Details`)}
        </h4>
        <div>
          {viewType === "view" ? (
            <Link
              className="text-success blue-icon blue-color4"
              to={`#`}
              onClick={() => setViewType("edit")}
              title={t(`Voter Details.Edit Details`)}
            >
              <img src={edit_icon} alt="delete_icon" />
            </Link>
          ) : (
            <button
              onClick={() => {
                setViewType("view");
                handleReset();
              }}
              className="btn btn-secondary"
            >
              {t(`Voter Details.Cancel`)}
            </button>
          )}
        </div>
      </div>
      {viewType === "edit" && (
        <div className="filters-cards-cross">
          <form
            onSubmit={handleSubmit}
            id="schedulef2f"
            style={{ display: "block" }}
          >
            <div className="form-group">
              <div className="row">
                <div className="voter-upload">
                  <label className="btn btn-primary upload-button">
                    <FontAwesomeIcon icon={faUpload} />
                    <span className="mx-2">
                      {t(`Voter Details.Upload Government ID`)}
                    </span>
                    <input
                      type="file"
                      multiple
                      accept={imageTypeAllowed.join(",")}
                      onChange={e => {
                        handleFileUpload(e);
                      }}
                      style={{ display: "none" }}
                    />
                  </label>
                  {attachmentFile && (
                    <FontAwesomeIcon
                      className="mx-1"
                      icon={faImages}
                      style={{ cursor: "pointer" }}
                      width={"25px"}
                      height={"25px"}
                      onClick={() => handleAttachmentOpen()}
                    />
                  )}
                  <p className="pb-2">
                    {t(`Voter Details.Supported file types are`)}
                  </p>

                  {errors?.attachmentFile && (
                    <p className="text-danger mt-2 mx-1">
                      {errors?.attachmentFile}
                    </p>
                  )}
                </div>
                <div className="row form-upload-card">
                  <div className="col-lg-4 col-md-6 mb-4">
                    <span className="font-size-14">
                      {t(`Voter Details.Government ID Number`)}
                    </span>
                    <div className="mt-2">
                      <input
                        for="voterId"
                        type="text"
                        className="form-control"
                        placeholder={t(`Voter Details.Enter Government ID`)}
                        value={userDetails?.voterIdNumber}
                        onChange={e => {
                          setUserDetails({
                            ...userDetails,
                            voterIdNumber: e.target.value,
                          });
                          setErrors({ ...errors, voterIdNumber: "" });
                        }}
                        title={`${t(`Voter Details.Government ID Number`)}`}
                      />
                    </div>
                    {errors?.voterIdNumber && (
                      <p className="text-danger mt-2 mx-1">
                        {errors?.voterIdNumber}
                      </p>
                    )}
                  </div>
                  <div className="col-lg-4 col-md-6 mb-4">
                    <span className="font-size-14">
                      {t(`Voter Details.Name`)}
                    </span>
                    <div className="mt-2">
                      <input
                        for="name"
                        type="text"
                        className="form-control"
                        placeholder={t(`Voter Details.Enter Full Name`)}
                        value={userDetails?.fullName}
                        onChange={e => {
                          setUserDetails({
                            ...userDetails,
                            fullName: e.target.value,
                          });
                          setErrors({ ...errors, fullName: "" });
                        }}
                        title={`${t(`Voter Details.Name`)}`}
                      />
                    </div>
                    {errors?.fullName && (
                      <p className="text-danger mt-2 mx-1">
                        {errors?.fullName}
                      </p>
                    )}
                  </div>
                  <div className="col-lg-4 col-md-6 mb-4">
                    <span className="font-size-14">
                      {t(`Voter Details.Parent's/Spouse's Name`)}
                    </span>
                    <div className="mt-2">
                      <input
                        for="spouseName"
                        type="text"
                        className="form-control"
                        placeholder={t(
                          `Voter Details.Enter Parent's/Spouse's Name`
                        )}
                        value={userDetails?.parentName}
                        onChange={e => {
                          setUserDetails({
                            ...userDetails,
                            parentName: e.target.value,
                          });
                          setErrors({ ...errors, parentName: "" });
                        }}
                        title={`${t(`Voter Details.Parent's/Spouse's Name`)}`}
                      />
                    </div>
                    {errors?.parentName && (
                      <p className="text-danger mt-2 mx-1">
                        {errors?.parentName}
                      </p>
                    )}
                  </div>
                  <div className="col-lg-4 col-md-6 mb-4">
                    <span className="font-size-14">
                      {t(`Voter Details.Gender`)}
                    </span>
                    <div className="mt-2">
                      <select
                        for="gender"
                        className="form-control"
                        onChange={e => {
                          setUserDetails({
                            ...userDetails,
                            gender: e.target.value,
                          });
                          setErrors({ ...errors, gender: "" });
                        }}
                        value={userDetails?.gender}
                        onMouseEnter={e => {
                          e.target.setAttribute(
                            "title",
                            e.target.options[e.target.selectedIndex].text
                          );
                        }}
                      >
                        <option value="Male">{t(`Voter Details.Male`)}</option>
                        <option value="Female">
                          {t(`Voter Details.Female`)}
                        </option>
                        <option value="Other">
                          {t(`Voter Details.Other`)}
                        </option>
                      </select>
                    </div>
                    {errors?.gender && (
                      <p className="text-danger mt-2 mx-1">{errors?.gender}</p>
                    )}
                  </div>
                  <div className="col-lg-4 col-md-6 mb-4">
                    <span className="font-size-14">
                      {t(`Voter Details.Date of Birth`)}
                    </span>
                    <div className="mt-2">
                      <DatePicker
                        selected={
                          userDetails?.dob ? new Date(userDetails?.dob) : ""
                        }
                        showYearDropdown
                        name="dob"
                        onChange={date => {
                          setUserDetails({
                            ...userDetails,
                            dob: date,
                          });
                          setErrors({ ...errors, dob: "" });
                        }}
                        className="form-control"
                        dateFormat="dd-MM-yyyy"
                        scrollableYearDropdown
                        // showYearPicker
                        maxDate={new Date()?.setFullYear(
                          new Date()?.getFullYear() - 18
                        )}
                        placeholderText={t(`Voter Details.Select Date`)}
                        title={`${t(`Voter Details.Date of Birth`)}`}
                      />
                    </div>
                    {errors?.dob && (
                      <p className="text-danger mt-2 mx-1">{errors?.dob}</p>
                    )}
                  </div>
                  <div className="col-lg-4 col-md-6 mb-4">
                    <span className="font-size-14">
                      {t(`Voter Details.Address`)}
                    </span>
                    <div className="mt-2">
                      <input
                        for="address"
                        type="text"
                        className="form-control"
                        placeholder={t(`Voter Details.Enter Address`)}
                        onChange={e => {
                          setUserDetails({
                            ...userDetails,
                            address: e.target.value,
                          });
                          setErrors({ ...errors, address: "" });
                        }}
                        value={userDetails?.address}
                        title={`${t(`Voter Details.Address`)}`}
                      />
                    </div>
                    {errors?.address && (
                      <p className="text-danger mt-2 mx-1">{errors?.address}</p>
                    )}
                  </div>
                  <div className="col-lg-4 col-md-6 mb-4">
                    <span className="font-size-14">
                      {t(`Voter Details.Issued On`)}
                    </span>
                    <div className="mt-2">
                      <DatePicker
                        selected={
                          userDetails?.issueDate
                            ? new Date(userDetails?.issueDate)
                            : ""
                        }
                        showYearDropdown
                        name="dob"
                        onChange={date => {
                          setUserDetails({
                            ...userDetails,
                            issueDate: date,
                          });
                          setErrors({ ...errors, issueDate: "" });
                        }}
                        className="form-control"
                        dateFormat="dd-MM-yyyy"
                        maxDate={new Date()}
                        placeholderText={t(`Voter Details.Select Date`)}
                        title={`${t(`Voter Details.Issued On`)}`}
                      />
                    </div>
                    {errors?.issueDate && (
                      <p className="text-danger mt-2 mx-1">
                        {errors?.issueDate}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="serach-btn d-flex justify-content-start">
                <button className="btn btn-primary search">
                  {t(`Voter Details.Save`)}
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
      {viewType === "view" && candidateDetails && (
        <>
          <div className="personal-card">
            <div className="document-detail-badge">
              <label className="data-label">
                {t(`Voter Details.Government ID Number`)}
              </label>
              <p className="text-wrap text-truncate-2 ">
                {generateMaskedPII(candidateDetails?.voterIdNumber, 2)}
              </p>
            </div>
            <div className="document-detail-badge">
              <label className="data-label">{t(`Voter Details.Name`)}</label>
              <p className="text-wrap text-truncate-2 ">
                {candidateDetails?.fullName}
              </p>
            </div>
            <div className="document-detail-badge">
              <label className="data-label">
                {t(`Voter Details.Parent's/Spouse's Name`)}
              </label>
              <p className="text-wrap text-truncate-2 ">
                {candidateDetails?.parentName}
              </p>
            </div>
            <div className="document-detail-badge">
              <label className="data-label">{t(`Voter Details.Gender`)}</label>
              <p className="text-wrap text-truncate-2 ">
                {candidateDetails?.gender}
              </p>
            </div>
            <div className="document-detail-badge">
              <label className="data-label">
                {t(`Voter Details.Date of Birth`)}
              </label>
              <p className="text-wrap text-truncate-2 ">
                {new Date(candidateDetails?.dob)?.toDateString()}
              </p>
            </div>
            <div className="document-detail-badge">
              <label className="data-label">{t(`Voter Details.Address`)}</label>
              <p className="text-wrap text-truncate-2 ">
                {candidateDetails?.address}
              </p>
            </div>
            <div className="document-detail-badge">
              <label className="data-label">
                {t(`Voter Details.Issued On`)}
              </label>
              <p className="text-wrap text-truncate-2 ">
                {new Date(candidateDetails?.issueDate)?.toDateString()}
              </p>
            </div>
            <div className="document-detail-badge">
              <label className="data-label">
                {t(`Voter Details.Document`)}
                {attachmentFile &&
                !checkPermissionStatus("personal-id-info", "view_unmasked") ? (
                  <>
                    {" "}
                    <FontAwesomeIcon
                      icon={faLock}
                      title="You are not authorized to view this document"
                    />
                  </>
                ) : (
                  <></>
                )}
              </label>
              <p className="text-wrap text-truncate-2 ">
                {attachmentFile && (
                  <FontAwesomeIcon
                    className="mx-4"
                    icon={faImages}
                    style={{ cursor: "pointer" }}
                    width={"25px"}
                    height={"25px"}
                    onClick={() =>
                      !checkPermissionStatus(
                        "personal-id-info",
                        "view_unmasked"
                      )
                        ? null
                        : handleAttachmentOpen()
                    }
                  />
                )}
              </p>
            </div>
          </div>
          <div className="line-braker"></div>
        </>
      )}
      {viewType === "view" && !candidateDetails && (
        <p className="pdf-details">{t(`Voter Details.No Details Available`)}</p>
      )}
    </>
  );
};

export default VoterDetails;
